/* =========================================================
   MANEWAY PRODUCT PAGE
   - Gallery: side arrows on the main image, dots, arrow keys.
     Uses Dawn's <media-gallery>.setActiveMedia so variant images,
     zoom and video keep working.
   - Reviews link under the title: only clickable when a reviews
     widget is on the page.
   Styles: assets/mw-product.css.
========================================================= */

(function () {
  'use strict';

  var CHEVRON_LEFT = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg>';
  var CHEVRON_RIGHT = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>';

  function visible(el) {
    return el && getComputedStyle(el).display !== 'none';
  }

  function initGallery(gallery) {
    if (gallery.mwReady) return;
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;
    gallery.mwReady = true;

    var thumbs = gallery.querySelector('[id^="GalleryThumbnails"]');

    // Media ids in display order, skipping ones the theme hides (variant images).
    function ids() {
      if (thumbs) {
        return Array.prototype.slice.call(thumbs.querySelectorAll('[data-target]'))
          .filter(visible)
          .map(function (li) { return li.getAttribute('data-target'); });
      }
      return Array.prototype.slice.call(viewer.querySelectorAll('[data-media-id]'))
        .map(function (el) { return el.getAttribute('data-media-id'); });
    }

    function currentId() {
      if (thumbs) {
        var cur = thumbs.querySelector('button[aria-current]');
        if (cur) return cur.closest('[data-target]').getAttribute('data-target');
      }
      var active = viewer.querySelector('[data-media-id].is-active');
      return active ? active.getAttribute('data-media-id') : ids()[0];
    }

    // Gallery images are lazy-loaded, so the next one would only start downloading
    // on click and the empty frame flashes. Load them ahead of time instead.
    function warm(img) {
      if (!img || img.mwWarm) return;
      img.mwWarm = true;
      img.loading = 'eager';
      if (img.decode) img.decode().catch(function () {});
    }

    function mediaImg(id) {
      var el = viewer.querySelector('[data-media-id="' + id + '"]');
      return el && el.querySelector('img');
    }

    function warmAround(id) {
      var list = ids();
      var i = list.indexOf(id);
      if (i < 0) return;
      warm(mediaImg(list[(i + 1) % list.length]));
      warm(mediaImg(list[(i - 1 + list.length) % list.length]));
    }

    function warmAll() {
      viewer.querySelectorAll('[data-media-id] img').forEach(warm);
    }

    function go(id) {
      warm(mediaImg(id));
      warmAround(id);
      if (typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(id, false);
      }
      update();
    }

    function step(direction) {
      var list = ids();
      if (list.length < 2) return;
      var i = list.indexOf(currentId());
      var next = list[(Math.max(i, 0) + direction + list.length) % list.length];
      go(next);
    }

    // Arrows on the main image.
    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'mw-gallery-arrow mw-gallery-arrow--prev';
    prev.setAttribute('aria-label', 'Previous image');
    prev.innerHTML = CHEVRON_LEFT;

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'mw-gallery-arrow mw-gallery-arrow--next';
    next.setAttribute('aria-label', 'Next image');
    next.innerHTML = CHEVRON_RIGHT;

    prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); step(-1); });
    next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); step(1); });
    viewer.appendChild(prev);
    viewer.appendChild(next);

    // Neighbours right away, then the rest once the page has finished loading.
    warmAround(currentId());
    prev.addEventListener('pointerenter', function () { warmAround(currentId()); });
    next.addEventListener('pointerenter', function () { warmAround(currentId()); });
    if (document.readyState === 'complete') {
      setTimeout(warmAll, 300);
    } else {
      window.addEventListener('load', function () { setTimeout(warmAll, 300); }, { once: true });
    }

    // Dots.
    var dots = document.createElement('div');
    dots.className = 'mw-gallery-dots';
    dots.setAttribute('role', 'tablist');
    dots.setAttribute('aria-label', 'Product images');
    gallery.appendChild(dots);

    dots.addEventListener('click', function (e) {
      var dot = e.target.closest('[data-media-target]');
      if (dot) go(dot.getAttribute('data-media-target'));
    });

    function update() {
      var list = ids();
      var cur = currentId();
      var single = list.length < 2;

      prev.hidden = single;
      next.hidden = single;
      dots.hidden = single;
      if (single) return;

      if (dots.children.length !== list.length) {
        dots.innerHTML = list.map(function (id, i) {
          return '<button type="button" class="mw-gallery-dot" role="tab" data-media-target="' + id + '" aria-label="Image ' + (i + 1) + ' of ' + list.length + '"></button>';
        }).join('');
      }

      Array.prototype.forEach.call(dots.children, function (dot, i) {
        var on = list[i] === cur;
        dot.setAttribute('data-media-target', list[i]);
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    // Keep dots in sync with thumbnail clicks, swipes and variant changes.
    var observer = new MutationObserver(function () {
      window.requestAnimationFrame(update);
    });
    observer.observe(gallery, { subtree: true, attributes: true, attributeFilter: ['aria-current', 'class'], childList: true });
    viewer.addEventListener('slideChanged', function () { setTimeout(update, 550); });
    window.addEventListener('resize', update);

    // Keyboard arrows while the gallery has focus.
    gallery.addEventListener('keydown', function (e) {
      if (e.target.matches('input, textarea, select')) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
    });

    update();
  }

  function initReviewsLink() {
    document.querySelectorAll('[data-mw-reviews-link]').forEach(function (link) {
      var target = document.querySelector('#judgeme_product_reviews, .jdgm-review-widget, [data-mw-reviews]');
      if (!target) {
        link.removeAttribute('href');
        return;
      }
      link.addEventListener('click', function (e) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* "Order today, arrives around …" in the Shipping tab (business days). */
  function addBusinessDays(date, days) {
    var d = new Date(date);
    while (days > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) days -= 1;
    }
    return d;
  }

  function initShippingEta() {
    document.querySelectorAll('[data-mw-ship]').forEach(function (box) {
      var el = box.querySelector('[data-mw-ship-date]');
      if (!el) return;
      var n = function (attr) { return parseInt(box.getAttribute(attr), 10) || 0; };
      var today = new Date();
      var from = addBusinessDays(today, n('data-p-min') + n('data-t-min'));
      var to = addBusinessDays(today, n('data-p-max') + n('data-t-max'));
      var fmt;
      try {
        fmt = new Intl.DateTimeFormat(document.documentElement.lang || undefined, { month: 'short', day: 'numeric' });
      } catch (e) {
        fmt = { format: function (d) { return d.toDateString().slice(4, 10); } };
      }
      el.textContent = fmt.format(from) + ' – ' + fmt.format(to);
    });
  }

  /* Sticky left column: if it's taller than the screen, stick its bottom
     edge instead of its top so the review under the images stays visible. */
  function initStickyMedia() {
    var wrapper = document.querySelector('.product__media-wrapper');
    if (!wrapper || wrapper.mwSticky) return;
    wrapper.mwSticky = true;

    var HEADER_GAP = 92;
    var BOTTOM_GAP = 16;

    function update() {
      if (window.innerWidth < 990) {
        wrapper.style.removeProperty('--mw-media-top');
        return;
      }
      var top = Math.min(HEADER_GAP, window.innerHeight - wrapper.offsetHeight - BOTTOM_GAP);
      wrapper.style.setProperty('--mw-media-top', top + 'px');
    }

    window.addEventListener('resize', update);
    window.addEventListener('load', update);
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(wrapper);
    update();
  }

  /* Quantity next to Add to cart: move the quantity picker into the button
     row. The input keeps its form="" attribute, so it still submits with
     the product form and the theme's variant updates find it by id. */
  function initBuyRow() {
    document.querySelectorAll('.product__info-container').forEach(function (info) {
      var qty = info.querySelector('.product-form__quantity');
      var buttons = info.querySelector('.product-form__buttons');
      var submit = buttons && buttons.querySelector('.product-form__submit');
      if (!qty || !submit || buttons.querySelector('.mw-qty-slot')) return;
      qty.classList.add('mw-qty-slot');
      buttons.insertBefore(qty, submit);
    });
  }

  function init() {
    initBuyRow();
    initStickyMedia();
    document.querySelectorAll('media-gallery').forEach(initGallery);
    initReviewsLink();
    initShippingEta();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
